export default "__VITE_ASSET__TZOyylwK__"